import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';


const DialogContentStyle = ({ theme }) => ({
  padding: '40px 0 100px 0',
  backgroundColor: theme.palette.background.grey.main,
  [theme.breakpoints.up('md')]: {
    padding: '60px 0 100px 0'
  }
});

const SummaryFormWrapper = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '3 / 11'
  }
});

export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
export const Wrapper = styled(Stack)(SummaryFormWrapper);
